import React, { useCallback } from 'react';
import { Button } from '@gravity-ui/uikit';
import { block } from '../../utils/cn';
import i18n from './i18n';
import './LabelFilterToggler.css';
import { jsx as _jsx } from "react/jsx-runtime";
var b = block('label-filters-toggler');
export function LabelFilterToggler(_ref) {
  var name = _ref.name,
    value = _ref.value,
    isMulty = _ref.isMulty,
    onClick = _ref.onClick,
    className = _ref.className;
  var onClickCallback = useCallback(function () {
    onClick(name);
  }, [name, onClick]);
  var text;
  if (name === 'queue' && !isMulty) {
    text = i18n("toggle_".concat(name));
  } else if (name.startsWith('cluster') && !isMulty) {
    text = i18n('toggle_cluster');
  } else {
    text = "".concat(i18n('toggle_default'), " ").concat(i18n(name), ": ").concat(value);
  }
  return /*#__PURE__*/_jsx(Button, {
    size: "s",
    onClick: onClickCallback,
    className: b(null, className),
    children: text
  });
}
// #sourceMappingURL=LabelFilterToggler.js.map